import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { TaskList } from '@/components/service-requests/tasks/task-list';
import { TaskForm } from '@/components/service-requests/tasks/task-form';
import { TaskDetails } from '@/components/service-requests/tasks/task-details';
import { useToast } from '@/hooks/use-toast';
import type { Task } from '@/lib/types';

type View = 'list' | 'form' | 'details';

export function TaskManagementPage() {
  const [view, setView] = useState<View>('list');
  const [selectedTask, setSelectedTask] = useState<Task | null>(null);
  const { toast } = useToast();

  const handleCreateTask = async (data: any) => {
    try {
      // Here you would make an API call to create the task
      console.log('Creating task:', data);
      
      toast({
        title: 'Success',
        description: 'Task created successfully',
      });
      setView('list');
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: 'Failed to create task',
      });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">
          {view === 'list' && 'Task Management'}
          {view === 'form' && 'Create Task'}
          {view === 'details' && 'Task Details'}
        </h1>
        <div className="flex gap-2">
          {view !== 'list' && (
            <Button
              variant="outline"
              onClick={() => {
                setView('list');
                setSelectedTask(null);
              }}
            >
              Back to List
            </Button>
          )}
          {view === 'list' && (
            <Button onClick={() => setView('form')}>
              <Plus className="mr-2 h-4 w-4" />
              Create Task
            </Button>
          )}
        </div>
      </div>

      {view === 'list' && (
        <TaskList
          onTaskClick={(task) => {
            setSelectedTask(task);
            setView('details');
          }}
        />
      )}

      {view === 'form' && (
        <TaskForm
          onSubmit={handleCreateTask}
        />
      )}

      {view === 'details' && selectedTask && (
        <TaskDetails
          task={selectedTask}
        />
      )}
    </div>
  );
}